import { render, staticRenderFns } from "./SingleScopeView.vue?vue&type=template&id=d261c316"
import script from "./SingleScopeView.vue?vue&type=script&lang=js"
export * from "./SingleScopeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports